import { render, staticRenderFns } from "./product_list_result.vue?vue&type=template&id=58fc5c56&scoped=true&"
import script from "./product_list_result.vue?vue&type=script&lang=js&"
export * from "./product_list_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fc5c56",
  null
  
)

export default component.exports